import React, { useState, useEffect } from "react";
import { Form, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";

const VerifyRejectReq = (props) => {
  const [listData] = useState([
    { name: "Approve", id: "1" },
    { name: "Hold", id: "2" },
    { name: "Reject", id: "0" },
  ]);
  const { id } = useParams();

  const [selectedStatus, setSelectedStatus] = useState("");
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  // Reset form when modal opens/closes
  useEffect(() => {
    if (props.show) {
      setSelectedStatus("");
      setComment("");
      setIsSubmitting(false);
      setErrors({});
    }
  }, [props.show]);

  const validateForm = () => {
    const newErrors = {};

    if (!selectedStatus) {
      newErrors.status = "Status is required";
    }

    if (selectedStatus && selectedStatus !== "1") {
      if (!comment.trim()) {
        newErrors.comment = "Reason is required when status is not Approve";
      } else if (comment.trim().length < 100) {
        newErrors.comment = "Reason must be at least 100 characters long";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!validateForm()) return;

    try {
      setIsSubmitting(true);

      const submitData = {
        status: selectedStatus,
        comment: selectedStatus === "1" ? "" : comment.trim(),
      };

      console.log("Submitting data:", submitData);

      await props.onSubmit(submitData);

      // Reset form
      setSelectedStatus("");
      setComment("");
      setErrors({});
    } catch (error) {
      console.error("Submit error:", error);
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setSelectedStatus("");
    setComment("");
    setIsSubmitting(false);
    setErrors({});
    props.onHide();
  };

  return (
    <div className="wrapper-assignpage">
      <Modal
        className="assign-modal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop={isSubmitting ? "static" : true}
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header className="text-center d-block ">
            <Modal.Title id="contained-modal-title-vcenter" className="f-14">
              Verify / Reject {props.moduleName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="wrapper-assignpage">
              <div className="dashboard">
                <div className="col-md-5">
                  <label htmlFor="student"> Select Status</label>
                  <Form.Select
                    value={selectedStatus}
                    onChange={(e) => setSelectedStatus(e.target.value)}
                    className="form-control"
                    aria-label="Default select example"
                    disabled={isSubmitting}
                  >
                    <option value="">Select</option>
                    {listData.map((item, i) => (
                      <option
                        key={i}
                        value={item.id}
                        disabled={
                          props.currentStatus === "1" && item.id === "1"
                        }
                      >
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                  {errors.status && (
                    <div className="input-field-error">{errors.status}</div>
                  )}
                </div>

                {selectedStatus && selectedStatus !== "1" && (
                  <div className="col-md-8 text-danger mt-3">
                    <label htmlFor="comment"> Reason</label>
                    <textarea
                      className="form-control"
                      style={{ height: "150px" }}
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      placeholder="Please provide detailed reason (minimum 100 characters)"
                      disabled={isSubmitting}
                    />
                    {errors.comment && (
                      <div className="input-field-error">{errors.comment}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center mt-4">
            <button
              type="button"
              className="cancel-btn add-btn"
              onClick={handleCancel}
              disabled={isSubmitting}
            >
              Discard
            </button>
            <button
              className="save-btn add-btn"
              type="submit"
              disabled={
                isSubmitting ||
                (props.currentStatus === "1" && selectedStatus === "1")
              }
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};

export default VerifyRejectReq;
